import controller from './chart-proximity-advanced.controller';
import { bindings } from '../chart-abstract-base';
import template from './template.html';

export default {
    bindings,
    template,
    controller
};
